module.exports = __webpack_public_path__ + "img/img_26@2x.4cdf0447.png";